export default __webpack_public_path__ + "2eaa3e52007460dfa4476dcb4e4147cb.jpg";